export var normalizeAngle = function (degrees) {
  var result = degrees;
  while (result < 0) result += 360;
  // removed this, when all angles are positive the animation doesn't do backwards overlapping
  while (result > 359) result -= 360;
  return result;
};